/* Bihari Swad theme — vanilla JS, no dependencies */
(() => {
  'use strict';

  const T = window.theme || { routes: {}, strings: {}, pincode: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CART_SECTION = 'cart-drawer';

  const once = (el, key) => {
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  };

  const debounce = (fn, ms) => {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  };

  /* ---------- Money ---------- */
  function formatMoney(cents, format = T.moneyFormat || '₹{{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    const fmt = (n, decimals, thousands = ',', dec = '.') => {
      const fixed = (n / 100).toFixed(decimals);
      const [whole, frac] = fixed.split('.');
      return whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`) + (frac ? dec + frac : '');
    };
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return fmt(cents, 2);
    let value;
    switch (match[1]) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function priceHTML(v, large) {
    const sale = v.compare_at_price && v.compare_at_price > v.price;
    let html = `<div class="price${sale ? ' price--sale' : ''}${large ? ' price--large' : ''}">`;
    html += `<span class="price__current">${formatMoney(v.price)}</span>`;
    if (sale) {
      const pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
      html += `<s class="price__compare">${formatMoney(v.compare_at_price)}</s>`;
      html += `<span class="price__save">${(T.strings.savePercent || '[percent]% off').replace('[percent]', pct)}</span>`;
    }
    return html + '</div>';
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;

  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('.drawer__panel button, .drawer__panel a, .drawer__panel input', d);
    if (focusable) setTimeout(() => focusable.focus(), 60);
  }

  function closeDrawer(d) {
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('.drawer.is-open, .search-modal.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('[data-drawer]')); return; }
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && T.cartType === 'drawer' && document.getElementById('CartDrawer')) {
      e.preventDefault();
      openDrawer('CartDrawer');
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
  });

  /* ---------- Cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function renderCart(sections) {
    if (!sections || !sections[CART_SECTION]) return;
    const doc = new DOMParser().parseFromString(sections[CART_SECTION], 'text/html');
    const fresh = $('.drawer__panel', doc);
    const current = $('#CartDrawer .drawer__panel');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function showFormError(form, message) {
    let el = $('[data-form-error]', form) || $('[data-form-error]', form.closest('[data-product-section]') || document.body);
    if (!el) { console.warn(message); return; }
    el.textContent = message;
    el.hidden = false;
    setTimeout(() => { el.hidden = true; }, 6000);
  }

  async function addToCart(form, btn) {
    const fd = new FormData(form);
    if (T.cartType === 'drawer') {
      fd.append('sections', CART_SECTION);
      fd.append('sections_url', window.location.pathname);
    }
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      const res = await fetch(`${T.routes.cart_add_url}.js`, {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const data = await res.json();
      if (!res.ok || data.status) throw data;
      if (T.cartType !== 'drawer' || !document.getElementById('CartDrawer')) {
        window.location.href = T.routes.cart_url;
        return;
      }
      renderCart(data.sections);
      const cart = await fetch(`${T.routes.cart_url}.js`).then((r) => r.json());
      updateCount(cart.item_count);
      if (!form.closest('#CartDrawer')) {
        $$('[data-search-modal].is-open').forEach(() => closeSearch());
        openDrawer('CartDrawer');
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (err) {
      showFormError(form, (err && (err.description || err.message)) || T.strings.error);
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-product-form], [data-quick-add]')) return;
    e.preventDefault();
    addToCart(form, e.submitter || $('[type="submit"]', form));
  });

  async function changeLine(key, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-loading');
    try {
      const res = await fetch(`${T.routes.cart_change_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: CART_SECTION, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw data;
      renderCart(data.sections);
      updateCount(data.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    } catch (err) {
      if (lineEl) lineEl.classList.remove('is-loading');
      const box = $('#CartDrawer [data-cart-error]');
      if (box) { box.textContent = (err && err.description) || T.strings.error; box.hidden = false; }
    }
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cart-qty]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.dataset.cartQty, parseInt(b.dataset.qtyValue, 10), b.closest('.mini-item'));
  });

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-qty]'));
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    const val = parseInt(input.value || '1', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Header ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (!header || !once(header, 'init')) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    const setH = () => document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
    setH();
    window.addEventListener('resize', debounce(setH, 150));
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Predictive search ---------- */
  let searchModal = null;
  function closeSearch() {
    if (!searchModal || !searchModal.classList.contains('is-open')) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
  }

  function initSearch() {
    searchModal = $('[data-search-modal]');
    if (!searchModal || !once(searchModal, 'init')) return;
    const input = $('[data-predictive-input]', searchModal);
    const results = $('[data-predictive-results]', searchModal);
    let controller;

    const run = debounce(async (q) => {
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const url = `${T.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const html = await fetch(url, { signal: controller.signal }).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = $('#shopify-section-predictive-search', doc);
        results.innerHTML = section ? section.innerHTML : '';
      } catch (err) { /* aborted */ }
    }, 250);

    input.addEventListener('input', () => run(input.value.trim()));

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        searchModal.classList.add('is-open');
        searchModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
        setTimeout(() => input.focus(), 60);
        return;
      }
      if (e.target.closest('[data-search-close]') || e.target === searchModal) { closeSearch(); return; }
      const chip = e.target.closest('[data-search-chip]');
      if (chip) { input.value = chip.dataset.searchChip; run(input.value); input.focus(); }
    });
  }

  /* ---------- Announcement rotator ---------- */
  function initRotators(root = document) {
    $$('[data-rotator]', root).forEach((el) => {
      if (!once(el, 'init')) return;
      const items = $$('.announcement__item', el);
      if (items.length < 2 || reduceMotion) return;
      let i = 0;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, parseInt(el.dataset.interval, 10) || 4000);
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2200);
  }

  /* ---------- Scroll-snap carousels (banners, gallery) ---------- */
  function bindTrack(track, dotsWrap, opts = {}) {
    const slides = Array.from(track.children);
    const dots = dotsWrap ? $$('button', dotsWrap) : [];
    let index = 0;
    const current = () => {
      const left = track.scrollLeft;
      let best = 0; let bestDist = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - track.offsetLeft - left - (parseFloat(getComputedStyle(track).paddingLeft) || 0) + (opts.center ? 0 : 0));
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    };
    const mark = (i) => {
      index = i;
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      if (opts.onChange) opts.onChange(i);
    };
    const go = (i) => {
      const s = slides[(i + slides.length) % slides.length];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingLeft) || 0), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    track.addEventListener('scroll', debounce(() => mark(current()), 60), { passive: true });
    dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
    track.goTo = go;
    return { go, get index() { return index; }, slides };
  }

  function initCarousels(root = document) {
    $$('[data-carousel]', root).forEach((track) => {
      if (!once(track, 'init')) return;
      const ctl = bindTrack(track, track.parentElement.querySelector('[data-carousel-dots]'));
      if (track.dataset.autoplay !== 'true' || reduceMotion || ctl.slides.length < 2) return;
      let timer;
      const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      const play = () => {
        clearInterval(timer);
        timer = setInterval(() => ctl.go(atEnd() ? 0 : ctl.index + 1), parseInt(track.dataset.speed, 10) || 5000);
      };
      ['pointerdown', 'mouseenter', 'focusin'].forEach((ev) => track.addEventListener(ev, () => clearInterval(timer), { passive: true }));
      ['mouseleave', 'touchend'].forEach((ev) => track.addEventListener(ev, play, { passive: true }));
      play();
    });
  }

  /* ---------- Search bar rotating term ---------- */
  function initSearchRotator() {
    const el = $('[data-search-rotator]');
    if (!el || !once(el, 'init') || reduceMotion) return;
    const terms = (el.dataset.terms || '').split(',').map((t) => t.trim()).filter(Boolean);
    if (terms.length < 2) return;
    let i = 0;
    setInterval(() => {
      el.style.opacity = '0';
      setTimeout(() => { i = (i + 1) % terms.length; el.textContent = terms[i]; el.style.opacity = '1'; }, 300);
    }, 2600);
  }

  /* ---------- Card weight selector ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-card-variant]');
    if (!sel) return;
    const opt = sel.options[sel.selectedIndex];
    const card = sel.closest('[data-pcard]');
    if (!card || !opt) return;
    const price = $('[data-card-price]', card);
    const cmp = $('[data-card-compare]', card);
    const off = $('[data-card-off]', card);
    if (price) price.textContent = opt.dataset.price;
    if (cmp) cmp.textContent = opt.dataset.compare || '';
    if (off) {
      const n = parseInt(opt.dataset.off, 10) || 0;
      off.hidden = n === 0;
      const num = $('[data-card-off-num]', off);
      if (num) num.textContent = `${n}%`;
    }
  });

  /* ---------- Coupon copy ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-copy-code]');
    if (!b) return;
    try { await navigator.clipboard.writeText(b.dataset.copyCode); } catch (err) { /* ignore */ }
    toast(`${T.strings.codeCopied || 'Copied'}: ${b.dataset.copyCode}`);
  });

  /* ---------- Tabs ---------- */
  function initTabs(root = document) {
    $$('[data-tabs]', root).forEach((el) => {
      if (!once(el, 'init')) return;
      const tabs = $$('[data-tab]', el);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        const seeAll = $('[data-see-all]', el);
        if (seeAll && tab.dataset.url) seeAll.href = tab.dataset.url;
      }));
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root = document) {
    $$('[data-countdown]', root).forEach((el) => {
      if (!once(el, 'init')) return;
      const end = new Date(el.dataset.end).getTime();
      if (Number.isNaN(end)) return;
      const out = {
        d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el)
      };
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) {
          el.classList.add('is-expired');
          if (el.dataset.hideExpired === 'true') el.closest('.shopify-section')?.setAttribute('hidden', '');
          return false;
        }
        out.d.textContent = pad(Math.floor(diff / 864e5));
        out.h.textContent = pad(Math.floor((diff % 864e5) / 36e5));
        out.m.textContent = pad(Math.floor((diff % 36e5) / 6e4));
        out.s.textContent = pad(Math.floor((diff % 6e4) / 1e3));
        return true;
      };
      if (tick()) {
        const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000);
      }
    });
  }

  /* ---------- Product page ---------- */
  function showMedia(root, id) {
    const track = $('[data-gallery-track]', root);
    if (!track) return;
    const slides = Array.from(track.children);
    const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
    if (i >= 0 && track.goTo) track.goTo(i);
  }

  function initGallery(root) {
    const gallery = $('[data-gallery]', root);
    if (!gallery || !once(gallery, 'init')) return;
    const track = $('[data-gallery-track]', gallery);
    const thumbs = $$('[data-thumb]', root);
    bindTrack(track, $('[data-gallery-dots]', gallery), {
      onChange: (i) => {
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
        $$('video', track).forEach((v, k) => { if (k !== i) v.pause(); });
      }
    });
    thumbs.forEach((t, k) => t.addEventListener('click', () => track.goTo(k)));
  }

  function initProduct(root = document) {
    $$('[data-product-section]', root).forEach((section) => {
      if (!once(section, 'init')) return;
      initGallery(section);
      const jsonEl = $('[data-product-json]', section);
      if (!jsonEl) return;
      const product = JSON.parse(jsonEl.textContent);
      const picker = $('[data-variant-picker]', section);
      const idInputs = $$('[data-variant-id]', section);
      const atcButtons = $$('[data-add-to-cart]', section);

      const setATC = (enabled, label) => {
        atcButtons.forEach((b) => {
          b.disabled = !enabled;
          const txt = $('[data-atc-text]', b);
          if (txt) txt.textContent = label;
        });
      };

      const updateAvailability = (selected) => {
        if (!picker) return;
        $$('fieldset', picker).forEach((fs, idx) => {
          $$('.pill', fs).forEach((pill) => {
            const input = $('input', pill);
            const ok = product.variants.some((v) => v.available && v.options[idx] === input.value &&
              v.options.every((o, j) => j === idx || selected[j] == null || o === selected[j]));
            pill.classList.toggle('is-unavailable', !ok);
          });
        });
      };

      const onChange = () => {
        const selected = $$('fieldset', picker).map((fs) => {
          const c = $('input:checked', fs);
          return c ? c.value : null;
        });
        selected.forEach((val, i) => {
          const label = $(`[data-option-label="${i}"]`, picker);
          if (label) label.textContent = val || '';
        });
        updateAvailability(selected);
        const v = product.variants.find((x) => x.options.every((o, i) => o === selected[i]));
        if (!v) { setATC(false, T.strings.unavailable); return; }
        idInputs.forEach((i) => { i.value = v.id; });
        $$('[data-price]', section).forEach((el) => { el.innerHTML = priceHTML(v, el.dataset.price === 'large'); });
        setATC(v.available, v.available ? T.strings.addToCart : T.strings.soldOut);
        if (v.featured_media) showMedia(section, v.featured_media.id);
        const sku = $('[data-sku]', section);
        if (sku) sku.textContent = v.sku || '';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };

      if (picker) {
        picker.addEventListener('change', onChange);
        updateAvailability($$('fieldset', picker).map((fs) => ($('input:checked', fs) || {}).value));
      }

      // Sticky add to cart
      const sticky = $('[data-sticky-atc]', section);
      const mainBtn = $('.product__info [data-add-to-cart]', section);
      if (sticky) sticky.hidden = false;
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          document.body.classList.toggle('has-sticky-atc', show);
        }).observe(mainBtn);
      }

      // Recently viewed
      const item = $('[data-recent-item]', section);
      if (item) {
        try {
          const data = JSON.parse(item.textContent);
          const key = 'bs_recent';
          const list = JSON.parse(localStorage.getItem(key) || '[]').filter((p) => p.handle !== data.handle);
          list.unshift(data);
          localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
        } catch (e) { /* storage unavailable */ }
      }
    });
  }

  /* ---------- Pincode checker ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pincode-check]');
    if (!btn) return;
    const box = btn.closest('[data-pincode]');
    const input = $('input', box);
    const out = $('[data-pincode-result]', box);
    const pin = (input.value || '').trim();
    out.classList.remove('is-ok', 'is-error');
    if (!/^[1-9][0-9]{5}$/.test(pin)) {
      out.textContent = T.strings.pinInvalid;
      out.classList.add('is-error');
      return;
    }
    const list = String(T.pincode.list || '').split(/[\s,]+/).map((s) => s.trim()).filter(Boolean);
    const fast = list.includes('*') || list.some((p) => pin.startsWith(p));
    let msg = fast
      ? T.strings.pinFast.replace('[days]', T.pincode.fastDays)
      : T.strings.pinStandard.replace('[days]', T.pincode.standardDays);
    if (T.pincode.cod) msg += ' ' + T.strings.pinCod;
    out.textContent = msg;
    out.classList.add('is-ok');
    try { localStorage.setItem('bs_pincode', pin); } catch (err) { /* ignore */ }
    setPinDisplay(pin);
    if (box.hasAttribute('data-pincode-global')) setTimeout(() => closeDrawer(box.closest('[data-drawer]')), 1400);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.closest('[data-pincode] input')) {
      e.preventDefault();
      $('[data-pincode-check]', e.target.closest('[data-pincode]')).click();
    }
  });
  function setPinDisplay(pin) {
    $$('[data-pin-display]').forEach((el) => { el.textContent = pin; });
  }
  function initPincode(root = document) {
    let saved = null;
    try { saved = localStorage.getItem('bs_pincode'); } catch (e) { /* ignore */ }
    if (!saved) return;
    setPinDisplay(saved);
    $$('[data-pincode] input', root).forEach((i) => { if (!i.value) i.value = saved; });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(root = document) {
    $$('[data-recommendations]', root).forEach(async (el) => {
      if (!once(el, 'init')) return;
      try {
        const html = await fetch(el.dataset.url).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim().length && $('.pcard', fresh)) {
          el.innerHTML = fresh.innerHTML;
        } else {
          el.closest('.shopify-section')?.setAttribute('hidden', '');
        }
      } catch (e) {
        el.closest('.shopify-section')?.setAttribute('hidden', '');
      }
    });
  }

  /* ---------- Recently viewed ---------- */
  function initRecentlyViewed(root = document) {
    $$('[data-recently-viewed]', root).forEach((el) => {
      if (!once(el, 'init')) return;
      let list = [];
      try { list = JSON.parse(localStorage.getItem('bs_recent') || '[]'); } catch (e) { /* ignore */ }
      const current = el.dataset.current;
      list = list.filter((p) => p.handle !== current).slice(0, parseInt(el.dataset.limit, 10) || 4);
      const wrap = el.closest('.shopify-section');
      if (!list.length) { if (!window.Shopify || !window.Shopify.designMode) wrap?.setAttribute('hidden', ''); return; }
      const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      $('[data-recent-grid]', el).innerHTML = list.map((p) => `
        <div class="pcard">
          <a class="pcard__media" href="${esc(p.url)}" tabindex="-1">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy" width="500" height="500">` : ''}</a>
          <div class="pcard__body">
            <h3 class="pcard__title"><a href="${esc(p.url)}">${esc(p.title)}</a></h3>
            <div class="pcard__foot"><div class="price"><span class="price__current">${esc(p.price)}</span></div></div>
          </div>
        </div>`).join('');
      wrap?.removeAttribute('hidden');
    });
  }

  /* ---------- Collection filters ---------- */
  const submitFacets = debounce((form) => form.submit(), 650);
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.form && t.form.matches('[data-facet-form]')) {
      if (t.type === 'number') submitFacets(t.form);
      else t.form.submit();
      return;
    }
    if (t.matches('[data-autosubmit]') && t.form) t.form.submit();
  });

  /* ---------- Misc ---------- */
  document.addEventListener('click', async (e) => {
    const copy = e.target.closest('[data-copy-link]');
    if (copy) {
      e.preventDefault();
      try {
        await navigator.clipboard.writeText(copy.dataset.copyLink || window.location.href);
        const prev = copy.innerHTML;
        copy.textContent = T.strings.copied;
        setTimeout(() => { copy.innerHTML = prev; }, 2000);
      } catch (err) { /* ignore */ }
    }
  });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-confirm]');
    if (f && !window.confirm(f.dataset.confirm)) e.preventDefault();
  });

  /* ---------- Init ---------- */
  function initAll(root = document) {
    initRotators(root);
    initCarousels(root);
    initTabs(root);
    initCountdowns(root);
    initProduct(root);
    initPincode(root);
    initRecommendations(root);
    initRecentlyViewed(root);
  }

  const boot = () => {
    initHeader();
    initSearch();
    initSearchRotator();
    initAll();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    initHeader();
    initSearch();
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const track = e.target.closest('[data-carousel]');
    if (track && track.goTo) track.goTo(Array.from(track.children).indexOf(e.target));
    const tabBtn = e.target.closest('[data-tab]');
    if (tabBtn) tabBtn.click();
  });
})();
